<template lang="pug">
validation-observer(ref="observer", v-slot="{ validateWithInfo }")
  v-container.the-session-credit-form 
    v-row.px-5
      v-dialog(v-model="holder.dialog", hide-overlay, fullscreen)
        v-card(v-if="holder.selected_type")
          v-toolbar(dark, color="gokleenblue", flat, tile)
            v-btn(icon, dark, @click="closeInfo")
              v-icon mdi-close
            v-toolbar-title 
              | {{ holder.selected_type.name }}
            v-spacer
            v-toolbar-items
              v-btn(dark, text, @click="openTermAndCondition")
                | t&c
              v-btn(v-if="holder.selected_type.files", dark, text, @click="openFiles")
                | compare
          v-card-text
            v-textarea(
              :value="holder.selected_type.description",
              readonly,
              solo,
              flat,
              no-resize,
              rows="4",
              auto-grow,
              hide-details) 
      template(v-if="holder.step == 0")
        v-col.pt-0(cols="12")
          .main-title.gokleenblue--text.text-uppercase Service Package Form
        v-col.py-0(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="4")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }")
                  | Property Type
              v-col(cols="12", md="8")
                .py-2.px-1
                  validation-provider(mode="passive", name="property type", rules="required")
                    v-autocomplete(
                      v-model="item.property_type",
                      :items="listing.property_types",
                      item-text="name",
                      item-value="id",
                      solo,
                      flat,
                      hide-details,
                      return-object,
                      @change="onPropertyTypeChange",
                      placeholder="Select Property Type")
        v-col.pt-5(cols="12", v-if="item.property_type")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="4")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Service Address
              v-col(cols="12", md="8")
                .py-2.px-1
                  v-data-table.elevation-1(
                    :headers="listing.address_headers",
                    :items="listing.address",
                    mobile-breakpoint="300",
                    hide-default-header,
                    hide-default-footer)
                    template(v-slot:no-data)
                      | No Address Available
        v-col.pb-0(cols="12", v-if="item.property_type")
          v-expand-transition
            v-card.rounded-0(color="gokleenblue")
              v-row.px-2(no-gutters)
                v-col(cols="12", md="4")
                  .servicetype-title.text-uppercase.white--text.px-2.pt-5(
                    :class="{ 'text-center': breakpoint.lgAndUp }")
                    | Service Package
                v-col(cols="12", md="8")
                  .py-2.px-1
                    validation-provider(mode="passive", name="service package", rules="required")
                      v-data-table.elevation-1(
                        v-model="item.types",
                        :headers="listing.types_headers",
                        :items="listing.types",
                        mobile-breakpoint="300",
                        hide-default-header,
                        hide-default-footer)
                        template(v-slot:item.name="{ item }")
                          .main.pb-1.font-weight-bold
                            | {{ item.name }}
                          .sub-1.pb-1
                            | Price: {{ Currency + item.price }}
                          .sub-2.pb-1
                            | Session Remaining: {{ item.session_remaining + '/' + item.session }}
                          .sub-3.pb-1
                            | Session Expired On: {{ item.session_remaining > 0 ? GetFormattedDateString(item.session_expired) : '-' }}
                        template(v-slot:item.actions="{ item }")
                          v-checkbox.inline-block(
                            v-model="item.selected",
                            @click="onServiceTypeClick(item.id)",
                            hide-details)
                          v-icon.inline-block.pb-3.cursor-pointer(@click="showInfo(item)")
                            | mdi-information
                        template(v-slot:no-data)
                          | No Service Package Available
        v-col(cols="12")
          v-row(no-gutters, justify="center")
            v-col(cols="12", md="auto")
              v-btn(
                dark,
                x-large,
                :block="isMobile",
                rounded,
                color="primary",
                @click="validateWithInfo().then(submit)") CONTINUE
      template(v-if="holder.step == 1")
        v-col.py-0(cols="12")
          .main-title.gokleenblue--text.text-uppercase Summary
        v-col.mt-5(cols="12")
          v-card(flat, color="rgba(255, 255, 255, 0)")
            v-row(no-gutters)
              v-col(cols="12", md="8", offset-md="4")
                v-row.mb-5(no-gutters)
                  v-col.px-1(cols="12")
                    v-text-field.transparent-input.input-right-align(
                      prefix="SERVICE TYPE",
                      :value="selected_type_text",
                      color="gokleenblue",
                      solo,
                      flat,
                      readonly,
                      hide-details)
                  v-col.px-1(cols="12")
                    v-text-field.transparent-input.input-right-align(
                      prefix="SERVICE SESSION",
                      :value="total_session",
                      color="gokleenblue",
                      solo,
                      flat,
                      readonly,
                      hide-details)
                  v-col.px-1(cols="12")
                    v-text-field.transparent-input.input-right-align(
                      prefix="SERVICE RATES",
                      :value="Currency + ' ' + total_price",
                      color="gokleenblue",
                      solo,
                      flat,
                      readonly,
                      hide-details)
                  v-col.px-1(cols="12", v-if="item.cleaner_add")
                    v-text-field.transparent-input.input-right-align(
                      prefix="ADD CLEANER",
                      :value="Currency + ' ' + total_price",
                      color="gokleenblue",
                      solo,
                      flat,
                      readonly,
                      hide-details)
            v-divider
        v-col(cols="12")
          v-card(flat, color="rgba(255, 255, 255, 0)")
            v-row.mb-5(no-gutters)
              v-col(cols="4")
                .servicetype-title.text-uppercase.gokleenblue--text.text-center.pt-5 Total
              v-col(cols="8")
                .pt-2.px-1
                  v-text-field.transparent-input.input-right-align(
                    :value="Currency + ' ' + total_price_after_discount",
                    color="gokleenblue",
                    solo,
                    flat,
                    readonly,
                    hide-details)
            v-divider
        v-col(cols="12")
          v-row(no-gutters, justify="center")
            v-col.pa-2(cols="12", md="auto")
              v-btn(dark, x-large, :block="isMobile", rounded, color="primary", @click="proceedPayment") PROCEED PAYMENT
            v-col.pa-2(cols="12", md="auto")
              v-btn(dark, x-large, :block="isMobile", rounded, color="primary", @click="prev") BACK
</template>
<script>
import { TYPE_SERVICE_STATUS } from "@/helpers/DefaultValue";
import { DEFAULT_SESSIONCREDIT_VALUE } from "@/helpers/public/DefaultValue";
import ValidateMixins from "@/mixins/ValidateMixins.vue";
import { GetFormattedDateString } from "@/helpers/Date";
import { mapState, mapMutations } from "vuex";
import { WEBURL_PUBLIC } from "@/helpers/Url";
import axios from "@/plugins/axios";
export default {
  name: "TheSessionCredit",
  mixins: [ValidateMixins],
  data: () => ({
    holder: {
      step: 0,
      dialog: false,
      selected_type: null
    },
    listing: {
      types_headers: [
        { text: "name", align: "start", value: "name" },
        { text: "Actions", align: "end", value: "actions" }
      ],
      address_headers: [{ text: "name", align: "start", value: "name" }],
      property_types: [],
      service_types: [],
      types: [],
      address: [],
      address_original: []
    },
    item: Object.assign({}, DEFAULT_SESSIONCREDIT_VALUE),
    isBusy: false,
    TYPE_SERVICE_STATUS
  }),
  computed: {
    ...mapState("setting", ["Setting", "Currency", "UserInfo", "TermAndConditionUrl"]),
    ...mapState({ RCObject: "RC" }),
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    selected_types: function() {
      var selected = null;
      var list = this.listing.types.filter(x => x.selected);
      // only pick one
      if (list && list.length > 0) selected = list[0];
      return selected;
    },
    selected_type_text: function() {
      let text = null;
      if (this.selected_types) {
        text = this.selected_types.name;
      }
      return text;
    },
    total_price() {
      let total = 0;

      if (this.selected_types) {
        total = this.selected_types.price;
      }

      return total;
    },
    discount: function() {
      let discount = 0;
      // calculate discount price for user
      if (this.UserInfo && this.UserInfo.tier != null) {
        discount = this.UserInfo.tier.discount;
      }
      return discount;
    },
    discount_price: function() {
      let total = 0;
      if (this.discount > 0) {
        total = this.total_price * this.discount;

        // round off point to 2 decimal place
        total = Math.round(total * 100) / 100;
      }
      return total;
    },
    total_price_after_discount: function() {
      let total = 0;
      if (this.total_price > 0) {
        //double the price when add cleaner
        if (this.item.cleaner_add) {
          total = this.total_price * 2;
        } else {
          total = this.total_price;
        }
        total = total - this.discount_price;

        // round off point to 2 decimal place
        total = Math.round(total * 100) / 100;
      }

      return total;
    },
    total_session() {
      let session = 0;
      if (this.selected_types) {
        session = this.selected_types.session;
      }
      return session;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    GetFormattedDateString,
    ...mapMutations("spinner", ["setSpinnerLoading"]),
    initialize() {
      this.item = Object.assign({}, this.item, DEFAULT_SESSIONCREDIT_VALUE);
      this.getTypes();
      this.assignContactInfo();
    },
    assignContactInfo() {
      let loginUserInfo = this.UserInfo;
      // reset listing address everytime we try to get user contact info
      this.listing.address = [];
      if (loginUserInfo) {
        // check if address exist
        if (loginUserInfo.address) {
          let address = loginUserInfo.address;
          if (address && address.length > 0) {
            this.listing.address_original = address;
            this.assignAddressByPropertyType();
          }
        }
      }
    },
    assignAddressByPropertyType() {
      this.listing.address = [];
      // by default , we alway select first address (if property type already selected)
      if (this.item.property_type) {
        this.listing.address = this.listing.address_original
          .filter(x => x.property_type == this.item.property_type.id)
          .sort((a, b) => a.order - b.order)
          .map((item, index) => ({
            idx: index,
            selected: false,
            name: item.address,
            property_type: item.property_type,
            order: item.order
          }));
      }
    },
    getTypes() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.setSpinnerLoading(true);

      axios
        .get(WEBURL_PUBLIC.getSessionServiceType)
        .then(res => {
          let data = res.data;
          if (data.property_types && data.property_types.length > 0) {
            this.listing.property_types = data.property_types;
          }

          if (data.service_types && data.service_types.length > 0) {
            this.listing.service_types = data.service_types;
          }

          // set property type if got passed from booking form
          if (this.RCObject.property_type && this.RCObject.property_type.id > 0) {
            this.item.property_type = Object.assign({}, this.RCObject.property_type);
            this.onPropertyTypeChange();
          }

          this.isBusy = false;
          this.setSpinnerLoading(false);
        })
        .catch(() => {
          this.isBusy = false;
          this.setSpinnerLoading(false);
        });
    },
    submit(resp) {
      if (resp.isValid) {
        // check service type first if empty
        if (this.item.types.length > 0) {
          return this.next();
        }

        return this.$eventHub.$emit("on-show-snackbar", {
          message: "Please select at least one service type.",
          color: "error",
          position: {
            top: true
          },
          timeout: 10000
        });
      }
      let errors = resp.errors;
      if (errors) {
        for (const key in errors) {
          if (errors[key].length > 0) {
            this.$eventHub.$emit("on-show-snackbar", {
              message: JSON.stringify(errors[key][0]),
              color: "error",
              position: {
                top: true
              },
              timeout: 10000
            });
            break;
          }
        }
        this.onErrorFocus("observer");
      }
    },
    next() {
      this.holder.step = 1;
    },
    prev() {
      this.holder.step = 0;
    },
    proceedPayment() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.setSpinnerLoading(true);

      let param = {
        items: Object.assign({}, this.item)
      };

      // remove unused stuff if exist
      delete param.items.property_type;

      axios
        .post(WEBURL_PUBLIC.saveSessionCredit, param)
        .then(res => {
          if (res.data) {
            let data = JSON.parse(res.data.d);
            if (data) {
              this.$eventHub.$emit("on-show-snackbar", {
                message: data.message,
                color: data.status ? "blue" : "error",
                timeout: -1,
                position: {
                  top: true
                }
              });

              // only proceed if success
              if (data.status) {
                // if got checkout link, then open it in new tab
                if (data.checkout_link) {
                  window.open(data.checkout_link, "_blank");
                }

                this.isBusy = false;
                this.setSpinnerLoading(false);
                return this.goHomePage();
              }
            }
          }
          this.isBusy = false;
          this.setSpinnerLoading(false);
        })
        .catch(() => {
          this.isBusy = false;
          this.setSpinnerLoading(false);
        });
    },
    goHomePage() {
      this.$emit("update", { type: TYPE_SERVICE_STATUS.UNKNOWN.ID });
    },
    onServiceTypeClick(selected_id) {
      // clear type before add new
      this.item.types = [];

      // clear
      this.$nextTick(() => {
        // unselect other (only allow single select on service type)
        this.listing.types.forEach(element => {
          if (element.id != selected_id) {
            element.selected = false;
          }
        });

        // assign service types
        let service_types = this.listing.types.filter(x => x.selected);
        if (service_types != null && service_types.length > 0) {
          this.item.types = service_types.map(v => v.id);
        }
      });
    },

    showInfo(item) {
      this.holder.selected_type = item;
      this.holder.dialog = true;
    },
    closeInfo() {
      this.holder.selected_type = null;
      this.holder.dialog = false;
    },
    onPropertyTypeChange() {
      // everytime user change property type, we need to clear old service type select
      this.item.types = [];
      this.listing.types = [];

      // add service type base on property type id
      if (this.item.property_type.id > 0) {
        let id = this.item.property_type.id;
        this.listing.types = this.listing.service_types
          .filter(x => x.property_types.includes(id))
          .map((item, index) => ({
            idx: index,
            selected: false,
            ...item
          }));
      }

      // clear selected address everytime we change property type
      this.assignAddressByPropertyType();
    },
    openFiles() {
      var filePath = "/data/custom/quotations/" + this.holder.selected_type.id + "/" + this.holder.selected_type.files;
      window.open(filePath, "_blank");
    },
    openTermAndCondition() {
      window.open(this.TermAndConditionUrl, "_blank");
    }
  }
};
</script>
<style lang="scss">
.the-session-credit-form {
  .main-title {
    font-weight: 700;
    font-size: 22px;
  }
  input:disabled,
  textarea:disabled {
    color: rgba(100, 95, 95, 0.8);
  }
  hr {
    background: #1572b6;
    border-top: 1px solid;
  }
  .transparent-input {
    input,
    textarea,
    i,
    .v-text-field__prefix {
      color: #1572b6;
    }
    > .v-input__control > .v-input__slot {
      background: rgba(255, 255, 255, 0);
    }
  }
  .input-right-align {
    input {
      text-align: right;
    }
  }
  .inline-block {
    display: inline-block;
  }
  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
